import { render, staticRenderFns } from "./Reply.vue?vue&type=template&id=5740559e&scoped=true&"
import script from "./Reply.vue?vue&type=script&lang=js&"
export * from "./Reply.vue?vue&type=script&lang=js&"
import style0 from "./Reply.vue?vue&type=style&index=0&id=5740559e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740559e",
  null
  
)

export default component.exports